import { gql } from 'apollo-angular';
import { subDomainItemFragment } from './sub-domain.fragments';

export const SubDomainTitleQuery = gql`
  query SubDomainTitleQuery($id: ID!) {
    node(id: $id) {
      ... on SubDomain {
        id
        title
      }
    }
  }
`;

export const SubDomainWithMostSevereSeverityQuery = gql`
  query SubDomainWithMostSevereSeverityQuery($id: ID!, $filter: WorkspaceFilter) {
    node(id: $id) {
      ... on SubDomain {
        ...SubDomainItem

        workspaces(filter: $filter) {
          edges {
            mostSevereSeverity
          }
        }
      }
    }
  }
  ${subDomainItemFragment}
`;
